
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    // @Serenity.Decorators.panel()
    export class PsPanelGroupButtonDialog extends Serenity.EntityDialog<PsPanelGroupButtonRow, any> {
        protected getFormKey() { return PsPanelGroupButtonForm.formKey; }
        protected getIdProperty() { return PsPanelGroupButtonRow.idProperty; }
        protected getLocalTextPrefix() { return PsPanelGroupButtonRow.localTextPrefix; }
        protected getNameProperty() { return PsPanelGroupButtonRow.nameProperty; }
        protected getService() { return PsPanelGroupButtonService.baseUrl; }
        protected getDeletePermission() { return PsPanelGroupButtonRow.deletePermission; }
        protected getInsertPermission() { return PsPanelGroupButtonRow.insertPermission; }
        protected getUpdatePermission() { return PsPanelGroupButtonRow.updatePermission; }

        protected form = new PsPanelGroupButtonForm(this.idPrefix);

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                // self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("");
                this.calcDataOnGrid();

            });

            this.form.TouchPanelType.changeSelect2(e => {
                // var shopId = Q.toId(this.form.ConnectEdcFg.value);
                var sd : string = this.form.TouchPanelType.value;

                this.form.DtList.touchpanel = this.form.TouchPanelType.value; 
                // console.log(sd)
                // if (!Q.isEmptyOrNull(sd)) {
                //     Serenity.EditorUtils.setReadOnly(this.form.DtList, false);  
                                                             
                // }else{
                //     Serenity.EditorUtils.setReadOnly(this.form.DtList, true);
                // }
            
            });

        }

        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {

                var a = this.form.DtList.getItems().map(o => o.ItemButtonId)
                if (a.length > 0) {
                    var b = 0
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
                    this.form.DtList.TotalAmt_ = b
                } else {
                    this.form.DtList.TotalAmt_ = 0
                }

                

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var a = this.form.DtList.getItems().map(o => o.ItemButtonId)
                if (a.length > 0) {
                    var b = 0
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
                    this.form.DtList.TotalAmt_ = b
                } else {
                    this.form.DtList.TotalAmt_ = 0
                }

            });

        }


        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.isNew()) {
                GeniuzPOS.InitialData.PsPanelGroupButtonService.GetNextNumber({
                }, response => {
                    this.form.GroupButtonId.value = Number(response.Serial);
                });
            }
            this.form.DtList.myPassValue = this.entity.Id
            this.form.DtList.myPassValue2 = this.form.TouchPanelType.value;


            var sd : string = this.form.TouchPanelType.value;

            // console.log(sd)
            if (!Q.isEmptyOrNull(sd)) {
                Serenity.EditorUtils.setReadOnly(this.form.DtList, false);  
                // this.form.DtList.touchpanel = sd;                                          
            }else{
                Serenity.EditorUtils.setReadOnly(this.form.DtList, true);
            }


        }


    }
}